{
  "title": "Fear",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level illusion",
  "level": 3,
  "castingTime": "1 action",
  "range": "Self (30-foot cone)",
  "components": "V, S, M (a white feather or the heart of a hen)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You project a phantasmal image of a creature’s worst fears. Each creature in a 30-foot cone must succeed on a Wisdom saving throw or drop whatever it is holding and become frightened for the duration.",
    "While frightened by this spell, a creature must take the Dash action and move away from you by the safest available route on each of its turns, unless there is nowhere to move. If the creature ends its turn in a location where it doesn’t have line of sight to you, the creature can make a Wisdom saving throw. On a successful save, the spell ends for that creature."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
